import { ReactNode } from "react";
import { Btn } from "@/components/Btn";
import { Modal } from "@/components/dialogs/Modal";
import { formatDatum } from "@/lib/format";

export type ConflictEntry = {
  id: number;
  gastname: string;
  einheiten_namen: string;
  check_in: string;
  check_out: string;
  status: string;
};

type Props = {
  conflicts: ConflictEntry[];
  headline: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  onForce: () => void;
  onCancel: () => void;
};

export function ConflictModal({
  conflicts,
  headline,
  confirmLabel,
  cancelLabel = "Abbrechen",
  onForce,
  onCancel,
}: Props) {
  return (
    <Modal maxWidth={560}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
        <span className="material-icons-outlined" style={{ color: "#ef4444", fontSize: 24 }}>
          warning
        </span>
        <h2 style={{ fontSize: 16, fontWeight: 700, margin: 0, color: "var(--fg)" }}>
          Belegungskonflikt
        </h2>
      </div>
      <p style={{ fontSize: 13, color: "var(--fg-muted)", marginBottom: 16 }}>{headline}</p>
      <div style={{ border: "1px solid var(--border)", borderRadius: 8, overflow: "hidden", marginBottom: 20 }}>
        {conflicts.map((c, i) => (
          <div
            key={c.id}
            style={{
              padding: "10px 14px",
              borderBottom: i < conflicts.length - 1 ? "1px solid var(--border)" : "none",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
              fontSize: 13,
            }}
          >
            <div>
              <div style={{ fontWeight: 600 }}>{c.gastname}</div>
              <div style={{ color: "var(--fg-muted)", fontSize: 12 }}>
                {c.einheiten_namen} · {formatDatum(c.check_in)} – {formatDatum(c.check_out)}
              </div>
            </div>
            <span
              style={{
                fontSize: 11,
                background: "var(--bg-subtle)",
                padding: "2px 8px",
                borderRadius: 4,
                whiteSpace: "nowrap",
                color: "var(--fg-muted)",
              }}
            >
              #{c.id}
            </span>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
        <Btn variant="secondary" onClick={onCancel}>
          {cancelLabel}
        </Btn>
        <Btn variant="danger" onClick={onForce}>
          {confirmLabel}
        </Btn>
      </div>
    </Modal>
  );
}
